import { VirtualTableHeadCell } from "../../virtualized-table/types";
import { SelectColumnFilter } from '../../virtualized-table/components/filter';
import DownloadFile from "../download-file";
import PartNumberCell from "./part-number-cell";

export const softwareFilesHeadCells: VirtualTableHeadCell[] = [
    {
        accessor: 'fileName',
        Header: 'File Name',
        Filter: SelectColumnFilter,
        filter: 'textAndCheckbox',
    },
    {
        accessor: 'partNumber',
        Header: 'Part Number',
        Filter: SelectColumnFilter,
        filter: 'textAndCheckbox',
        component: PartNumberCell
    },
    {
        accessor: 'createdTime',
        Header: 'Uploaded Date',
        Filter: SelectColumnFilter,
        filter: 'textAndCheckbox',
    },
    {
        accessor: 'userId',
        Header: 'User ID',
        Filter: SelectColumnFilter,
        filter: 'textAndCheckbox',
    },
    {
        accessor: 'id',
        Header: 'SHA',
        Filter: SelectColumnFilter,
        filter: 'textAndCheckbox',
    },
    {
        accessor: 'downloadIcon',
        Header: 'Download',
        component: DownloadFile,
    },
];

export const softwareModemFilesHeadCells: VirtualTableHeadCell[] = [
    {
        accessor: 'fileName',
        Header: 'File Name',
        Filter: SelectColumnFilter,
        filter: 'textAndCheckbox',
    },
    {
        accessor: 'createdTime',
        Header: 'Uploaded Date',
        Filter: SelectColumnFilter,
        filter: 'textAndCheckbox',
    },
    {
        accessor: 'userId',
        Header: 'User ID',
        Filter: SelectColumnFilter,
        filter: 'textAndCheckbox',
    },
    {
        accessor: 'id',
        Header: 'SHA',
        Filter: SelectColumnFilter,
        filter: 'textAndCheckbox',
    },
    {
        accessor: 'downloadIcon',
        Header: 'Download',
        component: DownloadFile,
    },
];

export const softwareFilesSortableAccessors = {
    fileName: true,
    createdTime: true,
    createdBy: true,
    partNumber: true,
    fileTypeId: true,
    id: true,
};
